"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var react_apollo_1 = require("react-apollo");
var EmbeddedDatasourceLineageUpstreamDataQualityWarningsQueryGql_1 = require("../../queries/EmbeddedDatasourceLineageUpstreamDataQualityWarningsQueryGql");
var SiteUrlsContext_1 = require("../../urls/SiteUrlsContext");
var renderQueryResult_1 = require("../renderQueryResult");
var DataQualityWarningFragments_1 = require("./DataQualityWarningFragments");
// Passes props so that the popover dialog shows up on the left since the vizclient pane always appears on the right
// until we can port the sophisticated render side selection algorithm in ChromeTooltipWidget
function EmbeddedDatasourceDataQualityWarning(props) {
    return (React.createElement(SiteUrlsContext_1.SiteUrlsContext.Consumer, null, function (urls) {
        return React.createElement(react_apollo_1.Query, { query: EmbeddedDatasourceLineageUpstreamDataQualityWarningsQueryGql_1.EmbeddedDatasourceLineageUpstreamDataQualityWarningsQueryGql, variables: { embeddedDatasourceId: props.nodeId, first: 10, offset: 0 } }, function (result) { return renderQueryResult_1.renderQueryResult(result, { renderData: renderWarnings(urls) }); });
    }));
}
exports.EmbeddedDatasourceDataQualityWarning = EmbeddedDatasourceDataQualityWarning;
var empty = [];
function renderWarnings(urls) {
    return function (data) {
        var workbook = data.embeddedDatasources ? data.embeddedDatasources[0] : null;
        if (!workbook) {
            return null;
        }
        var props = {
            urls: urls,
            iconOnly: false,
            side: 'left',
            upstreamDataQualityWarnings: workbook.upstreamDataQualityWarningsConnection && workbook.upstreamDataQualityWarningsConnection.totalCount > 0 ?
                workbook.upstreamDataQualityWarningsConnection.nodes : empty
        };
        return React.createElement(DataQualityWarningFragments_1.RenderWarningsFromGraph, __assign({}, props));
    };
}
//# sourceMappingURL=DataQualityWarningEmbeddedDatasources.js.map